"use client";

import { hasData } from "@/lib/helpers";
import Section from "../components/Section";
import { Button, Dialog, Grid2, Logo, Typography } from "@repo/ui";
import {
  AutomobileIcon,
  SoftwareDevelopmentIcon,
  EducationIcon,
  ManufacturingIcon,
  SupplyChainIcon,
  HealthcareIcon,
} from "@spoctech/icons";
import { useState } from "react";
import RequestCallbackForm from "@/components/forms/RequestCallbackForm";

type GetStartedTodayProps = {
  sectionInfo: PageSections;
  data: {
    heading?: string;
    description?: string;
    buttonActionText?: string;
    buttonActionUrl?: string;
  };
};

const GetStartedToday = ({ data, sectionInfo }: GetStartedTodayProps) => {
  const [open, setOpen] = useState(false);

  if (!hasData(data)) return null;
  return (
    <Section
      className={`${sectionInfo.sectionClass} bg-gradient-to-r from-transparent from-10% to-slate-200 to-90%`}
      id={sectionInfo.sectionId}
    >
      <Grid2 container spacing={5} align="center">
        <Grid2 size={{ xs: 12, sm: 12, md: 7, lg: 7 }}>
          <Typography
            variant="h2"
            gutterBottom
            className="!text-4xl !text-zinc-900 !font-bold"
          >
            {data?.heading}
          </Typography>

          <Typography
            paragraph
            className="!text-gray-500 !text-lg"
            gutterBottom
          >
            {data?.description}
          </Typography>
          <Button
            color="primary"
            variant="contained"
            label={data?.buttonActionText || "Request a callback"}
            onClick={() => setOpen(true)}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 5, lg: 5 }} className="relative">
          <Logo className="w-28 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
          <div className="size-[325px] mx-auto">
            <div className="grid grid-rows-4 grid-cols-3 h-full justify-items-center place-content-center items-center">
              <div className="col-start-2 size-14 bg-white rounded-full shadow-md flex items-center justify-center self-end">
                <SoftwareDevelopmentIcon className="text-primary-main" />
              </div>
              <div className="col-start-1 size-14 bg-white rounded-full shadow-md flex items-center justify-center">
                <AutomobileIcon className="text-primary-main" />
              </div>
              <div className="col-start-3 size-14 bg-white rounded-full shadow-md flex items-center justify-center">
                <EducationIcon className="text-primary-main" />
              </div>
              <div className="col-start-1 size-14 bg-white rounded-full shadow-md flex items-center justify-center">
                <HealthcareIcon className="text-primary-main" />
              </div>
              <div className="col-start-3 size-14 bg-white rounded-full shadow-md flex items-center justify-center">
                <ManufacturingIcon className="text-primary-main" />
              </div>
              <div className="col-start-2 size-14 bg-white rounded-full shadow-md flex items-center justify-center self-start">
                <SupplyChainIcon className="text-primary-main" />
              </div>
            </div>
          </div>
        </Grid2>
      </Grid2>

      {/* Request callback popup */}
      <Dialog
        open={open}
        onOpenChange={setOpen}
        maxWidth="md"
        title="Request Callback"
      >
        <RequestCallbackForm />
      </Dialog>
    </Section>
  );
};

export default GetStartedToday;
